(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/helpers/teams-helpers.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/helpers/teams-helpers.js');

'use strict';

const logger = svs.arena.logger;
const {
  returnStatus,
  localStorageDataType
} = svs.arena.constants;
const {
  postWithdrawFromTeamAsync,
  postMemberNotificationAsync
} = svs.arena.service.teamsService;
const {
  showWithdrawalDialog,
  showWithdrawalOkDialog,
  showWithdrawalNotOkDialog,
  showWithdrawalLockedPlayerAccountDialog
} = svs.arena.shared.deposit.depositDialogs;
const {
  showSendMessageAllSuccess,
  showSendMessageError,
  showSendMessageSuccess
} = svs.arena.pages.teams.dialogs;

const saveStateToLocalStorage = async function (storeObject) {
  let storeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return await new Promise((resolve, reject) => {
    if (storeType) {
      svs.components.Storage.browser.set("syndicate-".concat(storeType), 'syndicate', storeObject, svs.components.Storage.constants.EXPIRES_10M, err => {
        if (err) {
          reject(err);
        }
        resolve();
      });
    } else {
      reject(new Error('Missing parameter: storeType'));
    }
  });
};
const getStateFromLocalStorage = async storeType => await new Promise(resolve => {
  svs.components.Storage.browser.get("syndicate-".concat(storeType), 'syndicate', (data, err) => resolve(data, err));
});
const removeStateFromLocalStorage = async storeType => await new Promise(resolve => {
  svs.components.Storage.browser.remove("syndicate-".concat(storeType), 'syndicate', err => resolve(err));
});
const getInviteFromLocalStorage = () => svs.components.Storage.browser.get(localStorageDataType.INVITE, 'syndicate');
const getDepositFromLocalStorage = () => svs.components.Storage.browser.get(localStorageDataType.DEPOSIT, 'syndicate');
const wagerDetailUrl = wager => {
  const productUrlMapping = svs.core.urlMapping.get("".concat(svs.utils.url.encode(wager.productName), "_BetDetail")) || '#';
  const toBeReturned = productUrlMapping.replace(':wagerId', wager.wagerId).replace(':currentDrawNumber', '').replace(':currentAddonDrawNumber?', '');
  return toBeReturned;
};
const getMultiWeekText = wager => {
  let multiWeek = '';
  if (wager.totalDrawCount > 1) {
    const weekNum = (wager.drawNumIndex > -1 ? wager.drawNumIndex : wager.completedDrawCount) + 1;
    if (wager.productName === 'Keno') {
      multiWeek = "speldag ".concat(weekNum, " av ").concat(wager.totalDrawCount);
    } else {
      multiWeek = "vecka ".concat(weekNum, " av ").concat(wager.totalDrawCount);
    }
  }
  return multiWeek;
};

const submitWithdrawFromTeam = async _ref => {
  let {
    amount,
    teamId,
    teamName
  } = _ref;
  logger.debug('submitWithdrawFromTeam: ', amount, teamId);
  if (amount !== '' && parseInt(amount, 10) > 0) {
    if (await showWithdrawalDialog(amount)) {
      logger.debug('submitWithdrawFromTeam, Do Withdraw...');
      const {
        data,
        error
      } = await postWithdrawFromTeamAsync(amount, teamId);
      logger.debug('submitWithdrawFromTeam, reply data, error: ', data, error);
      if (error) {
        if (error.code === '6 149') {
          logger.debug('Customer has locked player account');
          showWithdrawalLockedPlayerAccountDialog();
        } else {
          logger.info('Error while trying to deposit: ', error);
          await showWithdrawalNotOkDialog();
        }
        return {
          status: returnStatus.ERROR,
          error
        };
      }
      const track = {
        category: 'spela-tillsammans',
        action: 'withdraw_teamaccount',
        opt_label: 'withdraw'
      };
      svs.components.analytics.trackEvent(track);
      svs.components.account_balance.set(data.playerAccountBalance);
      await showWithdrawalOkDialog(amount, teamName);
      return {
        status: returnStatus.SUCCESS,
        memberBalance: data.memberBalance,
        syndicateBalance: data.syndicateBalance,
        playableAmount: data.playableAmount
      };
    }
    const track = {
      category: 'spela-tillsammans',
      action: 'withdraw_teamaccount',
      opt_label: 'cancel'
    };
    svs.components.analytics.trackEvent(track);
    logger.debug('submitDepositToTeam, Transfer canceled...');
    return {
      status: returnStatus.CANCEL
    };
  }
  return {
    status: returnStatus.ERROR,
    error: 'Missing amount'
  };
};

const shouldShowNewGame = _ref2 => {
  let {
    tooFewMembers,
    playableAmount
  } = _ref2;
  return !tooFewMembers && parseInt(playableAmount, 10) > 0;
};

const activeMembers = members => members === null || members === void 0 ? void 0 : members.filter(_ref3 => {
  let {
    memberState
  } = _ref3;
  return memberState === 'ACTIVE';
}).sort((a, b) => {
  if (a.memberRole !== b.memberRole) {
    return b.memberRole - a.memberRole;
  }
  return a.firstName.localeCompare(b.firstName);
});
const buildInviteLinkUrl = inviteId => {
  const localLink = "".concat(svs.core.urlMapping.get('playTogetherInviteLink'), "/").concat(inviteId);
  let baseUrl = window.location.hostname;
  if (baseUrl.startsWith('app.')) {
    baseUrl = baseUrl.replace('app.', '');
  }
  const extLink = "https://".concat(baseUrl).concat(svs.utils.url.makeInternal(localLink), "?rnc=true");
  return extLink;
};
const handleSendEmailAsync = async (teamId, customerIds, message, memberName, currentMemberId) => {
  if (message.length === 0) {
    return {
      error: true
    };
  }
  currentMemberId && customerIds.push(currentMemberId);
  const {
    error
  } = await postMemberNotificationAsync(teamId, customerIds, message);
  if (error) {
    showSendMessageError();
    return {
      error: true
    };
  }

  if ((customerIds.length === 1 || currentMemberId) && memberName) {
    showSendMessageSuccess(memberName.firstName, memberName.lastName);
    return;
  }
  showSendMessageAllSuccess();
};
svs.arena.pages.teams.helpers = {
  activeMembers,
  saveStateToLocalStorage,
  getStateFromLocalStorage,
  removeStateFromLocalStorage,
  getInviteFromLocalStorage,
  getDepositFromLocalStorage,
  wagerDetailUrl,
  getMultiWeekText,
  submitWithdrawFromTeam,
  shouldShowNewGame,
  buildInviteLinkUrl,
  handleSendEmailAsync
};

 })(window);